<template>
	<div>
		<span v-if="row[ this.field.slug + '_filename' ]" class="input-link"><span class="fa fa-cloud-download"></span><a :href="src" target="_blank">Download File</a></span>
		<span v-else>No File Available <span class="fa fa-times"></span></span>
	</div>
</template>

<script>
export default {

	props: [ 'row', 'field' ],

	computed: {
		src: function() {
			return this.row[ this.field.slug + '_filepath' ] + this.row[ this.field.slug + '_filename' ];
		}
	},
};
</script>
